type ClassLike =
  | string
  | number
  | null
  | undefined
  | false
  | ClassLike[]
  | Record<string, boolean | null | undefined>;

function flattenClassNames(value: ClassLike, output: string[]) {
  if (!value) {
    return;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    output.push(String(value));
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((entry) => flattenClassNames(entry, output));
    return;
  }

  Object.entries(value).forEach(([className, enabled]) => {
    if (enabled) {
      output.push(className);
    }
  });
}

export function cn(...inputs: ClassLike[]) {
  const classNames: string[] = [];
  inputs.forEach((input) => flattenClassNames(input, classNames));
  return classNames.join(' ');
}

export function formatDate(date: Date | string | number): string {
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(date));
}

export function formatCurrency(amount: number, currency: string = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
}
